// 中文作文範本數據，基於傳統中文寫作結構
export const essayTemplates = [
  // 記敘文範例
  {
    id: 'narrative-school-trip',
    type: 'narrative',
    title: '難忘的學校旅行',
    category: '記敘文',
    content: {
      recipient: '',
      sender: '',
      date: '',
      subject: '難忘的學校旅行',
      greeting: '',
      opening: '上個月，我們學校組織了一次到大嶼山的旅行。這次旅行讓我印象深刻，至今難以忘懷。',
      mainBody: "早上七點，我們在學校集合，大家都興奮不已。老師點名後，我們便坐上旅遊巴士出發了。一路上，同學們有說有笑，車廂裡充滿了歡聲笑語。\n\n到達大嶼山後，我們首先參觀了天壇大佛。那座巨大的銅佛莊嚴肅穆，令人肅然起敬。接著，我們乘坐纜車到昂坪村，從高空俯瞰整個島嶼，景色美不勝收。\n\n下午，我們到海灘進行活動。有的同學在沙灘上堆沙堡，有的在海邊撿貝殼，還有的在玩排球。我和幾個好朋友一起在海邊漫步，感受著海風的清涼。\n\n最令我難忘的是晚上的篝火晚會。大家圍坐在篝火旁，有的唱歌，有的跳舞，有的講故事。老師也加入其中，和我們一起玩遊戲。那一刻，師生之間的距離似乎拉近了許多。",
      conclusion: '這次旅行不僅讓我欣賞到美麗的風景，更重要的是增進了同學之間的友誼。我會永遠珍藏這段美好的回憶。',
      closing: ''
    },
    tips: [
      "記敘文要有清晰的時間線索",
      "詳細描寫人物、環境和事件",
      "運用適當的修辭手法增強表現力",
      "結尾要點明主題或感悟"
    ],
    expressions: [
      "從前...",
      "有一天...",
      "記得那是一個...",
      "時間過得真快...",
      "回想起來...",
      "那一刻，我突然明白...",
      "這件事讓我印象深刻...",
      "經過這次經歷...",
      "最後，我們...",
      "這個故事告訴我們..."
    ],
    structure: {
      opening: "開頭：點明時間、地點、人物、事件",
      mainBody: "主體：按時間順序詳細記述事件經過",
      conclusion: "結尾：總結感悟或點明意義"
    }
  },

  // 描寫文範例
  {
    id: 'descriptive-spring-garden',
    type: 'descriptive',
    title: '春天的花園',
    category: '描寫文',
    content: {
      recipient: '',
      sender: '',
      date: '',
      subject: '春天的花園',
      greeting: '',
      opening: '春天來了，學校的花園變得生機勃勃，處處充滿了春天的氣息。',
      mainBody: "走進花園，首先映入眼簾的是一片嫩綠的草地。小草剛剛從土裡探出頭來，像是給大地鋪上了一層綠色的地毯。草地上還點綴著幾朵小野花，白的、黃的、紫的，在微風中輕輕搖擺。\n\n花園的中央有一個小池塘，池水清澈見底。幾條小魚在水中自由自在地游來游去，偶爾浮到水面上吐個泡泡，然後又迅速地潛入水底。池塘邊種著幾棵柳樹，柳條垂下來，像少女的長髮一樣飄逸。\n\n最吸引人的是花園裡的各種花卉。櫻花樹上開滿了粉紅色的花朵，遠遠看去，像一片粉色的雲朵。桃花也不甘示弱，綻放出嬌豔的花朵，散發著淡淡的香味。還有那黃色的迎春花，像一個個小喇叭，似乎在宣告春天的到來。\n\n在陽光的照耀下，整個花園顯得格外美麗。蝴蝶在花叢中翩翩起舞，蜜蜂忙碌地採集花蜜，鳥兒在樹枝上歡快地歌唱。",
      conclusion: '這個春天的花園就像一幅美麗的畫卷，讓人流連忘返，感受到大自然的神奇和美好。',
      closing: ''
    },
    tips: [
      "按一定的空間順序進行描寫",
      "運用各種感官進行細緻描寫",
      "使用比喻、擬人等修辭手法",
      "突出描寫對象的特點"
    ],
    expressions: [
      "放眼望去...",
      "只見...",
      "映入眼簾的是...",
      "這裡的景色十分...",
      "遠遠看去...",
      "走近一看...",
      "在陽光的照耀下...",
      "微風輕拂...",
      "整個場面顯得...",
      "給人一種...的感覺"
    ]
  },

  // 說明文範例
  {
    id: 'expository-environmental-protection',
    type: 'expository',
    title: '環境保護的重要性',
    category: '說明文',
    content: {
      recipient: '',
      sender: '',
      date: '',
      subject: '環境保護的重要性',
      greeting: '',
      opening: '環境保護是當今世界面臨的重要課題。隨著工業化進程的加快，環境問題日益嚴重，保護環境已經刻不容緩。',
      mainBody: "首先，環境污染對人類健康造成嚴重威脅。空氣污染會導致呼吸系統疾病，水污染會引起消化系統問題，土壤污染會影響食品安全。根據世界衛生組織的數據，每年有數百萬人因環境污染而死亡。\n\n其次，環境破壞會導致生物多樣性的喪失。森林砍伐、濕地破壞、海洋污染等人類活動，使得許多物種面臨滅絕的危險。生物多樣性的減少會破壞生態平衡，影響整個地球的生態系統。\n\n再者，環境問題會影響經濟發展。自然災害的頻發、資源的枯竭、治理污染的成本等，都會給經濟帶來巨大損失。相反，發展綠色經濟、清潔能源等，可以創造新的就業機會和經濟增長點。\n\n最後，環境保護關係到子孫後代的福祉。我們有責任為下一代留下一個美好的地球家園。這不僅是道德責任，也是可持續發展的必然要求。",
      conclusion: '總而言之，環境保護不僅關係到我們每個人的健康和生活品質，更關係到人類的未來。我們必須立即行動起來，共同保護我們的地球家園。',
      closing: ''
    },
    tips: [
      "條理清晰，層次分明",
      "用事實和數據說話",
      "運用舉例、對比等說明方法",
      "語言準確、簡潔明了"
    ],
    expressions: [
      "首先...",
      "其次...",
      "再者...",
      "總而言之...",
      "由此可見...",
      "換句話說...",
      "舉例來說...",
      "根據調查顯示...",
      "事實證明...",
      "因此我們可以得出結論..."
    ]
  },

  // 議論文範例
  {
    id: 'argumentative-reading-benefits',
    type: 'argumentative',
    title: '閱讀的益處',
    category: '議論文',
    content: {
      recipient: '',
      sender: '',
      date: '',
      subject: '閱讀的益處',
      greeting: '',
      opening: '在數位化時代，雖然獲取資訊的方式越來越多樣化，但我認為閱讀書籍仍然是最重要的學習方式之一。',
      mainBody: "首先，閱讀能夠豐富我們的知識。書籍是人類智慧的結晶，通過閱讀，我們可以了解歷史、學習科學、欣賞文學，從而拓寬視野，增長見識。正如培根所說：「知識就是力量」，而閱讀正是獲取知識的最佳途徑。\n\n其次，閱讀有助於提高思維能力。在閱讀過程中，我們需要理解、分析、判斷書中的內容，這個過程鍛鍊了我們的邏輯思維和批判性思維。長期堅持閱讀的人，往往具有更強的思辨能力和創新能力。\n\n再者，閱讀能夠陶冶情操，提升精神境界。優秀的文學作品能夠淨化我們的心靈，培養我們的審美能力，使我們成為更有品味、更有修養的人。閱讀也是一種精神享受，能夠讓我們在繁忙的生活中找到內心的寧靜。\n\n有人可能會說，現在有了網路和影視作品，閱讀已經不那麼重要了。但我認為這種觀點是錯誤的。雖然網路資訊豐富，但往往缺乏深度；影視作品雖然生動，但無法替代文字的想像空間。只有通過閱讀，我們才能進行深度思考和學習。",
      conclusion: '綜上所述，閱讀對於個人成長和社會發展都具有重要意義。我們應該培養良好的閱讀習慣，讓閱讀成為我們生活中不可缺少的一部分。',
      closing: ''
    },
    tips: [
      "論點明確，論據充分",
      "邏輯嚴密，條理清晰",
      "運用事實論據和理論論據",
      "考慮反方觀點並予以駁斥"
    ],
    expressions: [
      "我認為...",
      "毫無疑問...",
      "眾所周知...",
      "有人認為...，但我覺得...",
      "雖然...，但是...",
      "不可否認...",
      "顯而易見...",
      "綜上所述...",
      "基於以上分析...",
      "因此，我們應該..."
    ]
  },

  // 應用文範例 - 通知
  {
    id: 'practical-school-notice',
    type: 'practical',
    title: '學校運動會通知',
    category: '應用文',
    content: {
      recipient: '全體師生',
      sender: '學生會',
      date: '2024年3月15日',
      subject: '關於舉辦春季運動會的通知',
      greeting: '',
      opening: '為了豐富校園文化生活，增強學生體質，培養團隊合作精神，學校決定舉辦春季運動會。',
      mainBody: "一、時間：2024年4月10日（星期三）上午8:00-下午5:00\n\n二、地點：學校運動場\n\n三、參加對象：全體師生\n\n四、比賽項目：\n1. 個人項目：100米、200米、400米、800米、1500米跑步，跳高、跳遠、鉛球\n2. 集體項目：4×100米接力、拔河比賽、團體操表演\n\n五、報名方式：\n各班級請於3月25日前將報名表交至學生會辦公室\n\n六、注意事項：\n1. 請各班級積極組織學生參加\n2. 參賽學生須身體健康，無運動禁忌症\n3. 比賽當天請穿著運動服裝和運動鞋\n4. 請各班級安排啦啦隊為參賽同學加油\n\n七、獎勵辦法：\n個人項目前三名將獲得獎狀和獎品\n集體項目優勝班級將獲得流動紅旗",
      conclusion: '希望全體師生積極參與，共同營造健康向上的校園氛圍。',
      closing: '學生會\n2024年3月15日'
    },
    tips: [
      "格式規範，要素齊全",
      "內容具體明確",
      "用詞準確得體",
      "條理清晰，便於理解"
    ],
    expressions: [
      "茲通知...",
      "現將有關事項通知如下...",
      "請各位注意...",
      "特此通知",
      "望周知",
      "請按時參加",
      "如有疑問，請聯繫...",
      "謝謝合作"
    ]
  },

  // 書信範例
  {
    id: 'letter-to-friend',
    type: 'letter',
    title: '給朋友的一封信',
    category: '書信',
    content: {
      recipient: '小明',
      sender: '小華',
      date: '2024年3月20日',
      subject: '',
      greeting: '親愛的小明：',
      opening: '你好！收到你的來信，我非常高興。聽說你在新學校生活得很好，我為你感到開心。',
      mainBody: "你在信中問我最近的學習情況，我來告訴你吧。這個學期我們增加了幾門新課程，其中最有趣的是電腦程式設計課。老師教我們用簡單的程式語言編寫小遊戲，雖然有時候會遇到困難，但解決問題後的成就感讓我很滿足。\n\n另外，我還參加了學校的文學社。每週我們都會聚在一起討論最近讀過的書籍，分享寫作心得。上個月我還在校刊上發表了一篇短篇小說，得到了老師和同學們的好評。\n\n說到課外活動，我想起你以前最喜歡打籃球了。我們學校的籃球隊最近在市級比賽中獲得了第二名，真希望你能在現場為我們加油。你在新學校有沒有繼續打籃球呢？\n\n對了，下個月是我的生日，我想邀請你來參加我的生日聚會。我已經聯繫了我們以前的幾個同學，大家都很想念你。如果你有時間的話，一定要來啊！",
      conclusion: '好了，今天就寫到這裡。期待你的回信，也希望我們能夠保持聯繫。',
      closing: '祝你\n學習進步，身體健康！\n\n你的朋友\n小華\n2024年3月20日'
    },
    tips: [
      "稱呼和署名要得體",
      "內容要真實自然",
      "語言要親切友好",
      "格式要正確規範"
    ],
    expressions: [
      "親愛的...",
      "敬愛的...",
      "您好！",
      "近來身體可好？",
      "很久沒有聯繫了...",
      "收到您的來信，十分高興...",
      "謝謝您的關心...",
      "希望您一切順利",
      "期待您的回信",
      "此致敬禮"
    ]
  },

  // 日記範例
  {
    id: 'diary-volunteer-work',
    type: 'diary',
    title: '志願服務日記',
    category: '日記',
    content: {
      recipient: '',
      sender: '',
      date: '2024年3月16日',
      subject: '',
      greeting: '',
      opening: '今天是一個特別的日子，我參加了學校組織的志願服務活動。',
      mainBody: "早上八點，我們一群同學在老師的帶領下來到了市區的一家養老院。剛進入養老院，我就被這裡溫馨的氛圍所感動。雖然設施不算豪華，但處處都體現著對老人的關愛。\n\n我們的任務是陪伴老人聊天，幫助他們做一些力所能及的事情。我被分配照顧一位叫李奶奶的老人。李奶奶今年已經85歲了，但精神很好，說話也很清楚。她告訴我她年輕時是一名教師，教了一輩子的小學生。\n\n聽著李奶奶講述她的人生經歷，我深深地被感動了。她經歷過戰爭年代的艱苦，見證了國家的發展變化，但始終保持著樂觀的態度。她說：「年輕人，要珍惜現在的美好生活，努力學習，將來為社會做貢獻。」\n\n下午，我們還為老人們表演了節目。有的同學唱歌，有的跳舞，有的講故事。看到老人們臉上洋溢的笑容，我感到無比的快樂和滿足。\n\n臨別時，李奶奶拉著我的手說：「孩子，謝謝你陪我度過了這麼愉快的一天。你們這些年輕人真好！」聽到這話，我的眼睛濕潤了。",
      conclusion: '通過今天的志願服務，我明白了什麼是真正的快樂。幫助別人，關愛他人，不僅能給別人帶來溫暖，也能讓自己的心靈得到淨化。我決定以後要經常參加這樣的活動。',
      closing: ''
    },
    tips: [
      "記錄真實的生活體驗",
      "表達真實的情感感受",
      "語言要自然流暢",
      "可以進行反思和總結"
    ],
    expressions: [
      "今天是...",
      "天氣...",
      "心情...",
      "今天發生了一件...",
      "我感到...",
      "通過今天的事情，我明白了...",
      "今天真是難忘的一天",
      "希望明天...",
      "我決定...",
      "今天的收穫是..."
    ]
  }
];

export const categories = [
  'all',
  '記敘文',
  '描寫文',
  '說明文',
  '議論文',
  '應用文',
  '書信',
  '日記',
  '報告',
  '演講稿',
  '評論',
  '建議書',
  '通知',
  '總結'
];

export const templateTypes = [
  { value: 'narrative', label: '記敘文' },
  { value: 'descriptive', label: '描寫文' },
  { value: 'expository', label: '說明文' },
  { value: 'argumentative', label: '議論文' },
  { value: 'practical', label: '應用文' },
  { value: 'letter', label: '書信' },
  { value: 'diary', label: '日記' },
  { value: 'report', label: '報告' }
];

export const usefulExpressions = {
  narrative: [
    "從前...", "有一天...", "記得那是一個...", "時間過得真快...",
    "回想起來...", "那一刻，我突然明白...", "這件事讓我印象深刻...",
    "經過這次經歷...", "最後，我們...", "這個故事告訴我們..."
  ],
  descriptive: [
    "放眼望去...", "只見...", "映入眼簾的是...", "這裡的景色十分...",
    "遠遠看去...", "走近一看...", "在陽光的照耀下...", "微風輕拂...",
    "整個場面顯得...", "給人一種...的感覺"
  ],
  expository: [
    "首先...", "其次...", "再者...", "總而言之...", "由此可見...",
    "換句話說...", "舉例來說...", "根據調查顯示...", "事實證明...",
    "因此我們可以得出結論..."
  ],
  argumentative: [
    "我認為...", "毫無疑問...", "眾所周知...", "有人認為...，但我覺得...",
    "雖然...，但是...", "不可否認...", "顯而易見...", "綜上所述...",
    "基於以上分析...", "因此，我們應該..."
  ],
  practical: [
    "茲通知...", "現將有關事項通知如下...", "請各位注意...", "特此通知",
    "望周知", "請按時參加", "如有疑問，請聯繫...", "謝謝合作"
  ],
  letter: [
    "親愛的...", "敬愛的...", "您好！", "近來身體可好？",
    "很久沒有聯繫了...", "收到您的來信，十分高興...", "謝謝您的關心...",
    "希望您一切順利", "期待您的回信", "此致敬禮"
  ],
  diary: [
    "今天是...", "天氣...", "心情...", "今天發生了一件...", "我感到...",
    "通過今天的事情，我明白了...", "今天真是難忘的一天", "希望明天...",
    "我決定...", "今天的收穫是..."
  ],
  report: [
    "根據調查...", "經過統計...", "數據顯示...", "調查結果表明...",
    "通過分析...", "建議採取以下措施...", "存在的問題有...", "解決方案包括...",
    "預期效果...", "總結如下..."
  ]
};
